module.exports = __webpack_public_path__ + "img/24.162414de.jpg";